import { useQuery } from "react-query";
import { getPlanSubjects } from "../services/school/PlanSubjects";
import { PagedRequestType } from "../types/PagedResults";

export const useGetPlanSubjectsQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        ['plan-subjects-pagination', JSON.stringify(data)],
        () => getPlanSubjects(data),
        options ? { ...options } : {}
    );